export const LibSets = [
  {
      "title": "Native Script",
      "icon": "nginx",
      "color": "onec-orange",
      "text": "Over 1 Years experience",
      "status": "INTERMEDIET"
  },
  {
      "title": "JQuery",
      "icon": "jquery",
      "color": "onec-orange",
      "text": "Over 7 Years experience",
      "status": "EXPERT"
  },
  {
      "title": "Electron",
      "icon": "electron",
      "color": "onec-blue",
      "text": "Over 5 Years experience",
      "status": "EXPERT"
  },
  {
    "title": "React JS",
    "icon": "atom",
    "color": "onec-blue",
    "text": "Less 5 Years experience",
    "status": "EXPERT"
},
  {
      "title": "React Native",
      "icon": "atom",
      "color": "onec-green",
      "text": "Less 5 Years experience",
      "status": "EXPERT"
  },
  {
      "title": "Node JS",
      "icon": "npm",
      "color": "onec-blue",
      "text": "Over 5 Years experience",
      "status": "EXPERT"
  },
  {
    "title": "Angular",
    "icon": "angular",
    "color": "onec-orange",
    "text": "Over 5 Years experience",
    "status": "EXPERT"
  },
  {
    "title": "IONIC",
    "icon": "ionic",
    "color": "onec-blue",
    "text": "Over 5 Years experience",
    "status": "EXPERT"
  },
  {
    "title": "Vue JS",
    "icon": "vue-dot-js",
    "color": "onec-green",
    "text": "Over 5 Years experience",
    "status": "EXPERT"
  },
  {
    "title": "Gorm",
    "icon": "go",
    "color": "onec-semiorange",
    "text": "Over 2 Years experience",
    "status": "EXPERT"
  },
]

